import path from 'path'

import { CSSProperties, HTMLAttributes, ReactNode } from 'react'

import TruncatedText from '~/core/TruncatedText'

const baseStyle: CSSProperties = {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
}

type FileNamePropsType = {
    maxLength?: number
    cssOnly?: boolean
    style?: { [key: string]: any }
    name?: string | null
    className?: string | null
    wrap?: boolean
    children?:
        | ReactNode
        | undefined
        | ((props: {
              base: string
              ext: string
              style: CSSProperties
              props: Omit<
                  FileNamePropsType,
                  'maxLength' | 'cssOnly' | 'children' | 'style' | 'wrap'
              >
          }) => ReactNode)
}

export default function FileName(props: FileNamePropsType) {
    const { maxLength, cssOnly, children, style, name, wrap, ...restProps } =
        props
    const fileName = typeof children === 'string' ? children : name || ''
    const newProps = { name, ...restProps }

    const renderFileName = ({ truncated }: { truncated: string }) => {
        const ext = path.extname(fileName)
        const base = path.basename(truncated, ext)
        const _style = {
            ...baseStyle,
            ...style,
        }

        if (wrap) {
            delete _style.whiteSpace
        }

        return typeof children === 'function' ? (
            children({
                base,
                ext,
                style: _style,
                props: newProps,
            })
        ) : (
            <span
                {...(newProps as HTMLAttributes<HTMLSpanElement>)}
                style={_style}
            >
                {base}
                {Boolean(ext && ext.length) && (
                    <span style={{ fontWeight: 100 }}>{ext}</span>
                )}
            </span>
        )
    }

    return (
        <TruncatedText body={fileName} maxLength={maxLength} cssOnly={cssOnly}>
            {renderFileName}
        </TruncatedText>
    )
}
